<template>
    <p>Hall of fame</p>
    <h5>
        Løs alle 25 trin for at komme på listen
        <template v-if="!this.profile">
            <br>
            Login for at komme i gang!
        </template>
    </h5>
    <div v-if="!this.hall_of_fame">
        Indlæser...
    </div>
    <div v-else-if="this.hall_of_fame.length == 0" class="list">
        <div class="content-box">
            Ingen har klaret Kvikt endnu
        </div>
    </div>
    <div v-else class="list">
        <div v-for="(user, i) in this.hall_of_fame" :key="user.username" class="content-box">
            <div class="badge" :aria-label="`${i + 1}`">
                {{ i + 1 }}
            </div>
            <div class="user-content">
                <span class="username">{{ user.username }}</span>
                <span class="datetime">{{ this.formatTime(user.at) }}</span>
            </div>
        </div>
    </div>
    <h5>
        Skriv til mig på discord hvis du møder problemer
        <br>
        (alek.dk 385440602633797635)
    </h5>
</template>

<script>
import axios from "axios"

export default {
    data() {
        return {
            hall_of_fame: null,
            profile: null
        }
    },

    created() {
        this.profile = localStorage.getItem("profile");
    },

    async mounted() {
        try {
            const response = await axios.get("poll-hall-of-fame");
            if (response.status == 200) {
                this.hall_of_fame = response.data.users;
            }
        } catch (err) {
            console.error(err)
        }
    },

    methods: {
        formatTime(time) {
            const parts = time.split("T");
            return parts[0] + " " + parts[1].split(".")[0];
        }
    }
}
</script>

<style scoped>
    p {
        font-size: 30px;
        color: #b8b6b6;
    }

    h5 {
        font-weight: 525;
        color: #b8b6b6;
    }

    .badge {
        position: absolute;
        top: 8px;
        left: 8px;
        color: black;
        font-weight: 750;
        font-size: 16px;
        padding: 4px 4px;
        pointer-events: none;
    }

    .list { 
        display: grid;
        justify-content: center;
        gap: 20px; 
    }

    .content-box {
        padding-inline: 12px;
        min-height: 35px;
        padding-top: 5px;
        width: 550px;
        background-color: #979696;
        position: relative;
        display: block;
    }

    .user-content {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
        width: 100%;
    }

    .username {
        grid-column: 2;
        justify-self: center;
        font-weight: 750;
    }

    .datetime {
        grid-column: 3;
        justify-self: end;
        font-size: 1rem;
        opacity: 0.75;
    }
</style>
